module.exports = formData => {
  if (formData.knowledgeOfConsumption) {
    return;
  }

  if (!formData.levelOfConsumption) {
    return {};
  }

  if (!formData.invoiceType) {
    return {};
  }
  if (formData.invoiceType === "g21") {
    switch (formData.levelOfConsumption) {
      case "minimum":
        return {
          dayConsumption: 1000,
          nightConsumption: 0
        };
      case "small":
        return {
          dayConsumption: 2000,
          nightConsumption: 0
        };
      case "average":
        return {
          dayConsumption: 5000,
          nightConsumption: 0
        };
      case "big":
        return {
          dayConsumption: 7000,
          nightConsumption: 0
        };
      case "huge":
        return {
          dayConsumption: 10000,
          nightConsumption: 0
        };
      default:
        return {};
    }
  } else if (formData.invoiceType === "g23") {
    switch (formData.levelOfConsumption) {
      case "minimum":
        return {
          dayConsumption: 500,
          nightConsumption: 500
        };
      case "small":
        return {
          dayConsumption: 1000,
          nightConsumption: 1000
        };
      case "average":
        return {
          dayConsumption: 2500,
          nightConsumption: 2500
        };
      case "big":
        return {
          dayConsumption: 3500,
          nightConsumption: 3500
        };
      case "huge":
        return {
          dayConsumption: 5000,
          nightConsumption: 5000
        };
      default:
        return {};
    }
  } else {
    return {};
  }
};
